import _ from 'lodash';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
const defaultConfig: SMH.PreviewWatermarkConfig = {
  font: '200 normal normal 17px/17px PingFang SC, Serif',
  textColor: 'rgba(192, 192, 192, .25)',
  textDeg: 20,
  textGridX: 210,
  textGridY: 140,
  textNumX: 10,
  textNumY: 10,
  x: 0,
  y: 0,
  zIndex: '0',
};

/**
 * 说明：绘制水印方法
 * 参数 watermarkConfig水印配置参数;userBaseInfo用户信息用于完善水印文字
 */
export const previewWatermark = (idSelector: string, textContent: string, cWidth: number, cHeight: number) => {
  // 参数为空则返回
  if (!idSelector || !textContent) {
    return;
  }

  // 构造水印内容
  const { font, textColor, textDeg, textGridX, textGridY, textNumX, textNumY, zIndex, x, y } = defaultConfig;

  // 删除旧canvas
  const canvasId = `myCanvas${idSelector}`;
  const videoObj = document.getElementById(idSelector);
  const myCanvasObj = document.getElementById(canvasId);
  if (videoObj) {
    if (myCanvasObj) {
      videoObj.removeChild(myCanvasObj);
    }
  } else {
    return;
  }

  // 设置canvas宽高，初始化dom，初始化必要参数
  const myCanvas = document.createElement('canvas');
  myCanvas.id = canvasId;
  myCanvas.height = cHeight;
  myCanvas.width = cWidth;
  myCanvas.style.position = 'absolute';
  myCanvas.style.zIndex = zIndex;
  myCanvas.style.overflow = 'hidden';
  videoObj.appendChild(myCanvas);
  const ctx = myCanvas.getContext('2d');
  if (!ctx) {
    return;
  }

  // 设置水印参数
  // 字体参数：italic bold 12px/20px arial,serif
  // ctx.font = `${fontWeight} ${fontSize}px/${fontSize}px ${fontFamily}`;
  ctx.font = font;
  ctx.fillStyle = textColor;
  ctx.rotate((-textDeg * Math.PI) / 180);
  ctx.translate(x, y);
  const textWidth = ctx.measureText(textContent).width;
  const textOffsetX = textGridY * Math.sin((textDeg * Math.PI) / 180);
  const textOffsetY = (textGridX + textWidth) * Math.sin((textDeg * Math.PI) / 180);
  for (let i = 0; i < textNumX; i++) {
    for (let j = 0; j < textNumY; j++) {
      ctx.fillText(
        textContent,
        i * (textWidth + textGridX) - textOffsetX * j,
        j * textGridY + textOffsetY * i + textGridY,
      );
    }
  }
};
